import {IdleValue} from 'idlize/IdleValue.mjs';
import {getOffset} from '@utils/commonUtils.js';

class StickyFiltersAndSorting {
	/**
	 * @param {!jQuery} $row
	 * @param {!jQuery} $contentContainer
	 */
	constructor($row, $contentContainer) {
		this.$row 			   = $row;
		this.$contentContainer = $contentContainer;
		this.isSticky   	   = false;

		this.init();
	}

	/**
	 * @private
	 */
	init() {
		this.headerMenuHeight = new IdleValue(() => ($('.originalMenu').height() + parseInt($('.originalMenu').css('padding-top')) + parseInt($('.originalMenu').css('padding-bottom')) + parseInt($('#infoLine').height())));
		this.stickyMinScrollTopLazy = new IdleValue(() => getOffset(this.$row[0]).top - this.headerMenuHeight.getValue());

		/**
		 * These values will be needed for calculating later but won't change can be calculated only once
		 * @type {IdleValue}
		 */
		this.staticStickyMaxScrollTop = new IdleValue(() => (
			this.$contentContainer.offset().top - this.$row.height() - this.headerMenuHeight.getValue()
		));

		this._initUpdateChecking();
	}

	setStickyMinScrollTop() {
		this.stickyMinScrollTopLazy = new IdleValue(() => getOffset(this.$row[0]).top - this.headerMenuHeight.getValue());
	}

	/**
	 * @private
	 */
	_initUpdateChecking() {
		const checkForUpdate = this.checkForUpdate.bind(this);

		if (document.documentElement.scrollTop) {
			checkForUpdate();
		}

		$(window).on('scroll', () => {
			requestAnimationFrame(checkForUpdate);
		});
	}

	/**
	 * @param {boolean?} forceRefresh
	 */
	checkForUpdate({forceRefresh = false} = {}) {
		const scrollTop = $(window).scrollTop();

		if (scrollTop > this.stickyMinScrollTopLazy.getValue() && scrollTop < this.getCurrentStickyMaxScrollTop()) {
			if (!this.isSticky || forceRefresh) {
				this.createStickiness();
			}
		} else if (this.isSticky || forceRefresh) {
			this.stopStickiness();
		}
	}

	/**
	 * @private
	 */
	createStickiness() {
		this.isSticky = true;
		this.$row
			.addClass('sticky')
			.css('top', this.headerMenuHeight.getValue());
	}

	/**
	 * @private
	 */
	stopStickiness() {
		this.isSticky = false;
		this.$row
			.removeClass('sticky')
			.css('top', 0);
	}

	/**
	 * @returns {number}
	 * @private
	 */
	getCurrentStickyMaxScrollTop() {
		return this.staticStickyMaxScrollTop.getValue() + this.$contentContainer.height();
	}

}

export default StickyFiltersAndSorting;